import * as actionTypes from './actionTypes';

export const setPartnerCommissionToUpdate=(partnerCommission)=>({
    type:actionTypes.SET_PARTNER_COMMISSION_TO_UPDATE,
    payload:partnerCommission
})